import React from 'react'
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { removererendergrid } from '../modules/formstore';
import WashMarkRenderer from "./RenderWashMark.js";
import { isEmpty } from '../modules/appLibrary';
import AGFunction from "./AGFunction";

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

//--------------------------------------------------------
//  洗濯マークGrid
//
//  id : 明細識別子
//  elemid:
//  table:
//  columninfo：カラム情報
//  rowData
//  fnc
//  onGridReady
//  onFirstDataRendered
//  ValueChanged:値変更イベント
//  DataRowChanged:行変更イベント
//--------------------------------------------------------
export default function WashGrid(props) {

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const fnc = props.fnc;
    const AGFunc = React.forwardRef(AGFunction);
    const AGRef = useRef();
    const entrylock = useSelector(state => state.form.entryformlock);
    const rerendergrid = useSelector(state => state.form.rerendergrid);
    const admin = useSelector(state => state.user.authority);
    const washnone = useSelector(state => state.menu.washnone);
    const washlist1 = useSelector(state => state.menu.washlist1);
    const washlist2 = useSelector(state => state.menu.washlist2);
    const washlist3 = useSelector(state => state.menu.washlist3);
    const washlist4 = useSelector(state => state.menu.washlist4);
    const washlist5 = useSelector(state => state.menu.washlist5);
    const washlist6 = useSelector(state => state.menu.washlist6);
    const washlist7 = useSelector(state => state.menu.washlist7);
    const dispatch = useDispatch();

    useEffect(() => {
        let g_row = props.dataRef.current;
        if (!isEmpty(g_row)) {
            setRowData(g_row);
        } else {
            setRowData([{ rowid: "0", mark1: washnone, mark2: washnone, mark3: washnone, mark4: washnone, mark5: washnone, mark6: washnone, mark7: washnone }]);
        }
    }, []);

    useEffect(() => {
        if (rerendergrid.indexOf(props.id) !== -1) {
            let g_row = props.dataRef.current;
            if (!isEmpty(g_row)) {
                if (g_row.length !== 0) setRowData(g_row);
                else
                    setRowData([{ rowid: "0", mark1: washnone, mark2: washnone, mark3: washnone, mark4: washnone, mark5: washnone, mark6: washnone, mark7: washnone }]);
            } else {
                setRowData([{ rowid: "0", mark1: washnone, mark2: washnone, mark3: washnone, mark4: washnone, mark5: washnone, mark6: washnone, mark7: washnone }]);
            }
            dispatch(removererendergrid({ rerendergrid: props.id }));
        }
    }, [rerendergrid]);

    function onGridReady(param) {
        setGridApi(param.api);
        setGridColumnApi(param.columnApi);
        if (isEmpty(props.onGridReady)) return;
        if (isEmpty(props.panel)) {
            props.onGridReady(param, props.id);     //将来不要
        } else {
            props.onGridReady(param, props.panel);
        }
    }
    function onFirstDataRendered(param) {
        if (isEmpty(props.onFirstDataRendered)) return;
        if (isEmpty(props.panel)) {
            props.onFirstDataRendered(param, props.id);     //将来不要
        } else {
            props.onFirstDataRendered(param, props.panel);
        }
    }

    function onCellValueChanged(params, id) {
        if (params.newValue === params.oldValue) return;

        fnc.current.modify();

        if (!isEmpty(props.ValueChanged)) props.ValueChanged(params);
    }

    function setwashdata(e) {
        let rowNode = gridApi.getRowNode("0");
        if (!isEmpty(e.mark1)) rowNode.setDataValue("mark1", e.mark1);
        if (!isEmpty(e.mark2)) rowNode.setDataValue("mark2", e.mark2);
        if (!isEmpty(e.mark3)) rowNode.setDataValue("mark3", e.mark3);
        if (!isEmpty(e.mark4)) rowNode.setDataValue("mark4", e.mark4);
        if (!isEmpty(e.mark5)) rowNode.setDataValue("mark5", e.mark5);
        if (!isEmpty(e.mark6)) rowNode.setDataValue("mark6", e.mark6);
        if (!isEmpty(e.mark7)) rowNode.setDataValue("mark7", e.mark7);
        fnc.current.searchlistclose();
    }

    const columnDefs = [
        { field: 'rowid', initialHide: true, hide: true },
        { field: 'mark1', cellRendererParams: { type: 0, }},
        { field: 'mark2', cellRendererParams: { type: 1, }},
        { field: 'mark3', cellRendererParams: { type: 2, }},
        { field: 'mark4', cellRendererParams: { type: 3, }},
        { field: 'mark5', cellRendererParams: { type: 4, }},
        { field: 'mark6', cellRendererParams: { type: 5, }},
        { field: 'mark7', cellRendererParams: { type: 6, }},
        {
            field: 'cmd', editable: false, width: 40,
            cellRendererParams: {
                type: 7,
                clicked: function (e) {
                    if (entrylock) return;
                    //検索リストOPEN
                    fnc.current.washlistopen({
                        doApply: setwashdata,
                        gridApi: gridApi
                    });
                }
            },
        },
        ];

    function getRowHeight(params) {
        return 100;
    };

    function NoMenuHeader(params) {
        return (
            <div className="ag-header-cell-label">
            <span className="ag-header-cell-text"></span>
            </div>
        );
    };

    function getContextMenuItems(params) {
        var ptnparam = "mark1=mark1,mark2=mark2,mark3=mark3,mark4=mark4,mark5=mark5,mark6=mark6,mark7=mark7";
        var result = [
                {
                    name: 'パターン呼出/削除',
                    tooltip: '登録済のパターンリストを表示し呼び出し及びパターン削除を行います',
                    action: function () {
                        //検索リストOPEN
                        const datainfo = { datatype: "5", dataid: "sm_ptn", primary: false, type: "wash" }
                        fnc.current.searchlistopen({
                            label: "パターン - 洗濯表示",
                            multiple: false,
                            rowmode: false,
                            data: datainfo,
                            doApply: SetPattern,
                        });
                        function SetPattern(e) {
                            fnc.current.searchlistclose();
                            fnc.current.postaxios('common/GetPattern', { code: e.value, type: "wash", note: ptnparam, request: e.shared ? "shared" : null },
                                {
                                    onSuccess: function (data) {
                                        setRowData(data.rowdata);
                                        fnc.current.wait();
                                    },
                                    errmsg: "パターン取得に失敗しました"
                                }
                            );
                        }
                        return;
                    },
                },
                {
                    name: 'パターン登録',
                    tooltip: '表示中の内容をパターン登録します',
                    action: function () {
                        let data = AGRef.current.GetDatasource(gridApi);
                        fnc.current.formdialogopen({
                            title: "パターン登録 - 洗濯表示", inputname: "パターン名", dialogtype: 0,
                            placeholder: "パターン名を入力してください",
                            contents: "表示中の内容を指定したパターン名で登録します",
                            customcontents: admin === "1" ? 2 : null,
                            checkboxlabel: "共有する（すべてのログインユーザーに公開されます）",
                            onApply: (value) => exec(value, false)
                        });
                        function exec(value, update) {
                            fnc.current.postaxios('common/PatternSave', { rowdata: data, key: value['name'], share: value['check'] ? "1" : "0", update: update, tabletype: "wash", initlayout: ptnparam, coldef: AGRef.current.GetshownColDef() },
                                {
                                    onSuccess: function (data) {
                                        fnc.current.wait();
                                        if (data.errDescription.length !== 0) {
                                            fnc.current.confmsg("このパターン名は登録済です。上書してよろしいですか？", () => exec(value, true));
                                        }
                                        else {
                                            fnc.current.success();
                                            fnc.current.formdialogclose();
                                        }
                                    },
                                    errmsg: "パターン登録に失敗しました"
                                }
                            );
                        }
                    },
        }];
        return result;
    };

    return (
        <div id={isEmpty(props.elemid) ? props.id : props.elemid} className="ag-theme-balham" style={{ width: 750 }}>
            <AgGridReact
                theme={themeBalham}
                columnMenu="legacy"
                getRowId={params => params.data.rowid}
                headerHeight={30}
                popupParent={document.querySelector('body')}
                domLayout={'autoHeight'}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                defaultColDef={{
                    headerComponent: NoMenuHeader,
                    filter: false,
                    sortable: false,
                    resizable: false,
                    cellRenderer: WashMarkRenderer,
                    cellRendererParams: {
                        washlist1: washlist1,
                        washlist2: washlist2,
                        washlist3: washlist3,
                        washlist4: washlist4,
                        washlist5: washlist5,
                        washlist6: washlist6,
                        washlist7: washlist7,
                        none: washnone
                    },
                    editable: true,
                    suppressMenu:true,
                    width:80,
                }}
                modules={[AllCommunityModule, AllEnterpriseModule]}
                getRowHeight={getRowHeight}
                onCellValueChanged={onCellValueChanged}
                columnDefs={columnDefs}
                rowData={rowData}
                getContextMenuItems={getContextMenuItems}
            >
            </AgGridReact>
            <AGFunc
                ref={AGRef}
                gridApi={gridApi}
                gridColumnApi={gridColumnApi}
                gridid={props.id}
            />
        </div>
    );

}